export default __webpack_public_path__ + "static/media/how-we-help-2.572b86f7.svg";